import useTranslations from "@/hooks/useTranslations";
import LanguageSwitcher from "@/Components/LanguageSwitcher";

export default function Footer({}) {
    const { __ } = useTranslations();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="mx-auto">
            <div className="mx-auto container w-full p-4 py-6 lg:py-8">
                <hr className="my-6 border-gray-200 dark:border-gray-700 sm:mx-auto lg:my-8"/>
                <div className="md:flex md:justify-between">
                    <div className="grid grid-cols-2 gap-8 sm:gap-6 sm:grid-cols-3">
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">{__('common.footer.company')}</h2>
                            <ul className="text-gray-500 dark:text-gray-400 font-medium">
                                <li className="mb-4">
                                    <a href="/blog" target="_blank" className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
                                        {__('common.footer.blog')}
                                    </a>
                                </li>
                                <li className="mb-4">
                                    <a href={route('contact')} className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
                                        {__('common.footer.contact')}
                                    </a>
                                </li>
                                <li>
                                    <a href={route('privacy')} className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
                                        {__('common.footer.privacy_policy')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h2 className="mb-6 text-sm font-semibold text-gray-900 uppercase dark:text-white">{__('common.footer.resources')}</h2>
                            <ul className="text-gray-500 dark:text-gray-400 font-medium">
                                <li className="mb-4">
                                    <a href={route('extract-hardcoded')}
                                       className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
                                        {__('common.footer.extract_subtitles')}
                                    </a>
                                </li>
                                <li className="mb-4">
                                    <a href={route('generate-subtitles')}
                                       className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
                                        {__('common.footer.generate_subtitles')}
                                    </a>
                                </li>
                                <li className="mb-4">
                                    <a href={route('faqs')}
                                       className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
                                        {__('common.footer.faqs')}
                                    </a>
                                </li>
                                <li className="mb-4">
                                    <a href="https://chromewebstore.google.com/detail/subtitle-extractor/mifpkhfchoibfhkcpiecalegnngapioj"
                                       target="_blank"
                                       className="text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100">
                                        {__('common.footer.chrome_extension')}
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="flex flex-col items-start md:items-end mt-6 md:mt-0">
                        <div className="mb-4">
                            <LanguageSwitcher />
                        </div>
                        <span className="text-sm text-gray-500 dark:text-gray-400 text-left md:text-right">
                            © {currentYear} <a href={route('home')} className="hover:underline">Subtitle Extractor</a>. {__('common.footer.rights')}
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
